import React from 'react'

const Referals = () => {
    return (
        <div>
            <h2>Referals</h2>
        </div>
    )
}

export default Referals
